export const CALC_TOTAL_SELLING_PRICE = 'CALC_TOTAL_SELLING_PRICE';

export const CALC_TOTAL_LIST_PRICE = 'CALC_TOTAL_LIST_PRICE';
